<template>
    <div class="blog-category-antlia__container">
        <div class="blog-category-antlia__introduction">
          <p class="blog-category-antlia__title"> {{ title }}</p>
        </div>
        <ul class="blog-category-antlia__container--list"
            id="js-blog-category-antlia">
            <li class="blog-category-antlia__item" v-for="categoria in categorias">
              <div class="blog-category-antlia__item--image">
                <img class="blog-category-antlia__item--img"
                :src="categoria.imagen"
                :alt="categoria.nombre"
                :title="categoria.nombre"
                >
              </div>
              <div class="blog-category-antlia__item--content">
                <p class="blog-category-antlia__item--title">{{ categoria.nombre }}</p>
                <p class="blog-category-antlia__item--paragraph">{{ categoria.descripcion }}</p>
                <a class="blog-category-antlia__item--link"
                    :href="categoria.url"
                    :title="categoria.nombre">
                    {{ vermas }}
                </a>
              </div>
            </li>
        </ul>
    </div>
</template>
<script>
    import axios from 'axios';
    export default {
        props:['title', 'url', 'vermas'],
        data(){
            return{
                categorias: []
            }
        },
        mounted(){
            var self = this
            axios.get(`${this.url}?img_size=390x440`)
              .then(function (response) {
                self.categorias = response.data.results
                setTimeout(function() {
                  $('#js-blog-category-antlia').owlCarousel({
                    loop: true, smartSpeed: 2000, items: 1, dots: true, nav: true,
                    navText: [
                      '<div class="blog-category-antlia__arrow-left"></div>',
                      '<div class="blog-category-antlia__arrow-right"></div>'
                    ],
                    responsive: {
                      768: { items: 2 },
                      1200: { items: 3 }
                    }
                  })
                }, 1);
              })
              .catch(function (error) {
                console.log(error);
            })
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/blog/ara/components/carruselCategorias.vue